/**
 * Brand detection and configuration.
 * Maps hostnames → brand identities for white-labeled login pages.
 * A ?brand=xxx query param works for previewing without a custom domain.
 */

export type BrandId = 'gewgul' | 'dealnet' | 'liquornet' | 'gofishingnet' | 'roadmover';

// ── hostname → brand map ──────────────────────────────────────────────────
const HOST_MAP: Record<string, BrandId> = {
  // DealNet domains
  'dealnet.com':          'dealnet',
  'www.dealnet.com':      'dealnet',
  'app.dealnet.com':      'dealnet',
  'godealnet.com':        'dealnet',
  'www.godealnet.com':    'dealnet',
  // RoadMover domains
  'roadmover.com':         'roadmover',
  'www.roadmover.com':     'roadmover',
  'app.roadmover.com':     'roadmover',
  // LiquorNet domains
  'liquornet.com':        'liquornet',
  'www.liquornet.com':    'liquornet',
  'app.liquornet.com':    'liquornet',
  // GoFishingNet domains
  'gofishingnet.com':     'gofishingnet',
  'www.gofishingnet.com': 'gofishingnet',
  'app.gofishingnet.com': 'gofishingnet',
  'fishingnet.com':       'gofishingnet',
  'www.fishingnet.com':   'gofishingnet',
};

/**
 * Detects which brand to show.
 * RoadMover's domain owns its branding. Other domains retain their existing
 * query-preview behavior.
 */
export function getDomainBrand(hostname: string): BrandId | undefined {
  return HOST_MAP[hostname.toLowerCase().replace(/\.$/, '')];
}

export function detectBrand(): BrandId {
  if (typeof window !== 'undefined') {
    const domainBrand = getDomainBrand(window.location.hostname);
    if (domainBrand === 'roadmover') return domainBrand;

    // Preserve existing previews on development and the other brands.
    const params = new URLSearchParams(window.location.search);
    const preview = params.get('brand') as BrandId | null;
    if (preview && ['dealnet', 'liquornet', 'gofishingnet', 'roadmover', 'gewgul'].includes(preview)) {
      return preview;
    }
    if (domainBrand) return domainBrand;
  }
  return 'gewgul';
}
